import { BACKSPACE_KEY, DELETE_KEY, ENTER_KEY } from '../constants/keys';

const hotkeysIgnore = ['y', 'z', 'a'];

const validateEvent = (event) => {
  if (event.key === BACKSPACE_KEY || event.key === DELETE_KEY || event.key === ENTER_KEY)
    return true;
  if (event.key && event.key.length !== 1) return false;
  return !(hotkeysIgnore.includes(event.key) && (event.metaKey || event.ctrlKey));
};

export default validateEvent;
